import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import Divider from '@mui/material/Divider';
import { H4, H6, Body2, Subtitle2 } from 'components/Typography';
import styles from './styles';
import { isNotNullOrEmpty, isEmptyObject } from 'utilities/is';
import m from 'messages';

class MissingCompetenciesView extends React.Component {

    extractDivision(c) {
        if (c.divisionSpecific) return `${c.name} (${c.divisionName})`;
        if (c.companySpecific) return `${c.name} (${c.companyName})`;
        if (c.cscsCardSchemeID) return `Compatible Skills Card - ${c.cscsCardSchemeName} - ${c.cscsCardType}`;
        if (c.employerName) return `${c.name} (${c.employerName})`
        return c.name;
    }

    extractProject(c) {
        if (c.divisionSpecific) return `${c.name} (${c.divisionName})`;
        if (c.projectSpecific) return `${c.name} (${c.projectName})`;
        if (c.companySpecific) return `${c.name} (${c.companyName})`;
        if (c.cscsCardSchemeID) return `Compatible Skills Card - ${c.cscsCardSchemeName} - ${c.cscsCardType}`;
        if (c.employerName) return `${c.name} (${c.employerName})`
        return c.name;
    }

    extractSite(c) {
        if (c.siteSpecific) return `${c.name} (${c.siteName})`;
        if (c.companySpecific) return `${c.name} (${c.companyName})`;
        if (c.divisionSpecific) return `${c.name} (${c.divisionName})`;
        if (c.cscsCardSchemeID) return `Compatible Skills Card - ${c.cscsCardSchemeName} - ${c.cscsCardType}`;
        if (c.employerName) return `${c.name} (${c.employerName})`
        return c.name;
    }

    extractZone(c) {
        if (c.zoneSpecific) return `${c.name} (${c.zoneName})`;
        if (c.companySpecific) return `${c.name} (${c.companyName})`;
        if (c.cscsCardSchemeID) return `Compatible Skills Card - ${c.cscsCardSchemeName} - ${c.cscsCardType}`;
        if (c.employerName) return `${c.name} (${c.employerName})`
        return c.name;
    }

    missingCompetences(groups, nameExtract) {

        let missingValues = [];

        Object.keys(groups).forEach((key, index) => {
            let group = groups[key];

            let allGroup = [];
            let orGroup = [];
            for (const item of group) {

                if (!isNotNullOrEmpty(item.orGroup)) {

                    if (allGroup.length === 0) {
                        allGroup.push({
                            label: m.cards.missingCompetenciesAll,
                            missingCompetenceNames: [nameExtract(item)]
                        });
                    } else {
                        allGroup[0].missingCompetenceNames.push(nameExtract(item));
                    }
                } else {
                    if (orGroup.length === 0) {
                        orGroup.push({
                            label: m.cards.missingCompetenciesAtLeast,
                            missingCompetenceNames: [nameExtract(item)]
                        });
                    } else {
                        orGroup[0].missingCompetenceNames.push(nameExtract(item));
                    }
                }
            }
            missingValues = missingValues.concat(allGroup).concat(orGroup);

        });
        return missingValues;
    }

    renderGroup(group, extractor, title) {
        const classes = this.props.classes;
        let missing = this.missingCompetences(group, extractor);
        return (
            <React.Fragment>
                {missing.length > 0 &&
                    <div className={this.props.classes.contentContainer}>
                        <H4 paragraph className={classes.warning}>{title}</H4>
                        <H6>
                            {m.cards.missingCompetenciesHeader}
                        </H6>
                        {missing.map((g, index) =>
                            <div key={index}>
                                <Subtitle2 className={classes.row}>{g.label}</Subtitle2>
                                {g.missingCompetenceNames.map((mc, index) =>
                                    <div className={classes.row} key={index}>
                                        <Body2 className={classes.row}>{mc}</Body2>
                                        <Divider />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                }
            </React.Fragment>
        );
    }

    render() {
        const { card, config, classes, location } = this.props;

        try {
            if (!location || isEmptyObject(location) || !Boolean(location.division)) { return (<div></div>); }

            return (
                <div className={classes.root}>
                    {this.renderGroup(card.missingDivisionCompetences, this.extractDivision, `${m.cards.invalidCompetenciesFor} ${config.divisionLevelName.toLowerCase()} ${location.division.divisionName}`)}
                    {this.renderGroup(card.missingProjectCompetences, this.extractProject, `${m.cards.invalidCompetenciesFor} ${config.projectLevelName.toLowerCase()} ${location.project.projectName}`)}
                    {this.renderGroup(card.missingSiteCompetences, this.extractSite, `${m.cards.invalidCompetenciesFor} ${config.siteLevelName.toLowerCase()} ${location.site.siteName}`)}
                    {location.zone && this.renderGroup(card.missingZoneCompetences, this.extractZone, `${m.cards.invalidCompetenciesFor} ${config.zoneLevelName.toLowerCase()} ${location.zone.zoneName}`)}
                </div>
            );
        } catch (e) {
            return (<div></div>);
        }
    }
}

MissingCompetenciesView.propTypes = {
    card: PropTypes.object,
    location: PropTypes.object,
    config: PropTypes.object
};

export default withStyles(MissingCompetenciesView,styles);